const sdkConfig = {
  serverUrl: "https://auth.bingeit.vip",
  clientId: "aba6c7231d0653244ddf",
  organizationName: "Bingeit.vip",
  appName: "Bingeit.vip",
  redirectPath: "/auth/callback",
  scope: "profile",
};

export default sdkConfig;
